import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    landingUrl: String,
  }

  static targets = ['copyButton', 'program', 'url'];

  copy () {
    const link = this.urlTarget.value;
    navigator.clipboard.writeText(link);
    this.copyButtonTarget.innerText = 'Copied!';
    setTimeout(() => { this.copyButtonTarget.innerText = 'Copy'; }, 2000);
  }

  setProgramUrl (e) {
    this.fetchLandings(e.target.value);
  }

  fetchLandings (id) {
    const myUrl = `${this.landingUrlValue}/?program_sfid=${id}`;
    fetch(myUrl)
      .then(response => response.json())
      .then((data) => {
        this.populateUrlTarget(data);
      });
  }

  populateUrlTarget (data) {
    const noLandingPageMessage = 'No landing page defined yet';
    const { url } = data;
    this.urlTarget.value = url.length > 0 ? url : noLandingPageMessage;
  }
}
